import React from 'react'

const CircleCheckIcon = () => {
  return (
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.295 3.29L4 6.585L2.205 4.795L1.5 5.5L4 8L8 4L7.295 3.29ZM5 0.5C2.24 0.5 0 2.74 0 5.5C0 8.26 2.24 10.5 5 10.5C7.76 10.5 10 8.26 10 5.5C10 2.74 7.76 0.5 5 0.5ZM5 9.5C2.79 9.5 1 7.71 1 5.5C1 3.29 2.79 1.5 5 1.5C7.21 1.5 9 3.29 9 5.5C9 7.71 7.21 9.5 5 9.5Z" />
    </svg>
  )
}
export default CircleCheckIcon
